<ng-container *ngIf="state$ | async as state">
  <div *ngIf="state.visible === true" data-tid-elfsight>
    <div *ngIf="isProd" class="elfsight-app-{{ state.widgetId }}" data-elfsight-app-lazy></div>
  </div>
</ng-container>
